import { createSlice, configureStore } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit/dist/createAction";

import {
  NormalizedCargo,
  NormalizedCargoItem,
  Route,
} from "../../../../../domain/models/cargo-model";
import {
  InventoryReservation,
  SeparationStatus,
} from "../../../../../domain/models/inventory-reservation";
import { act } from "react-dom/test-utils";

type separationState = {
  cargos: NormalizedCargo[];
  currentCargo: NormalizedCargo | null;
  currentItem: {
    reservation: InventoryReservation;
    item: NormalizedCargoItem;
  } | null;
  currentRoute: string;
};

const initialState: separationState = {
  cargos: [],
  currentCargo: null,
  currentItem: null,
  currentRoute: "",
};

const separationSlice = createSlice({
  name: "separation",
  initialState,
  reducers: {
    saveCargos: (
      state,
      action: PayloadAction<{ cargos: NormalizedCargo[] }>
    ) => {
      state.cargos = action.payload.cargos;
    },
    setCurrentCargo: (
      state,
      action: PayloadAction<{ cargo: NormalizedCargo }>
    ) => {
      state.currentCargo = action.payload.cargo;
    },
    setCurrentItem: (
      state,
      action: PayloadAction<{
        reservation: InventoryReservation;
        item: NormalizedCargoItem;
      }>
    ) => {
      state.currentItem = action.payload;
    },
    setCurrentRoute: (
      state,
      action: PayloadAction<{
        route: string;
      }>
    ) => {
      state.currentRoute = action.payload.route;
    },
  },
});

export const separationStore = configureStore({
  reducer: separationSlice.reducer,
});

export type SeparationState = ReturnType<typeof separationStore.getState>;
export type StoreDispatch = typeof separationStore.dispatch;
export const separationActions = separationSlice.actions;
